var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkAuthorization.admin)?_c('v-container',[_c('h1',[_vm._v("Admin migration page ")]),_c('div',[_c('BigDataConfigCard',{attrs:{"title":"Urgent deliveries","type":"ud"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }